import { PropTypes } from "prop-types";
import { useState, useEffect } from "react";
import { ActionsMenu } from "@evertrue/et-components";
import { bulkFetchContactsForJourney } from "apps/journeys/utils/api-requests/modal-actions";
import colors from "@evertrue/et-variables/src/styles/variables.scss";
import BulkMoveToJourneyModal from "../../modals/bulk-move-to-journey-modal";

const JourneysConstituentsActions = ({ selected, assignedContacts, handleRemove }) => {
  const [selectedContacts, setSelectedContacts] = useState([]);

  useEffect(() => {
    const getAndSetSelectedContacts = async () => {
      const selectedContactsArr = await bulkFetchContactsForJourney(selected);
      setSelectedContacts(selectedContactsArr);
    };

    getAndSetSelectedContacts();
  }, [selected]);

  return (
    <ActionsMenu
      options={[
        {
          id: 1,
          iconStyle: { color: colors.blue300 },
          label: "Move to Cadence",
          description: `Move ${selected.length} constituents to a cadence`,
          mountOnClick: ({ is_open, close }) => {
            return (
              <BulkMoveToJourneyModal
                isOpen={is_open}
                closeModal={close}
                selected={selectedContacts}
                assignedContacts={assignedContacts}
                handleRemove={handleRemove}
              />
            );
          },
        },
      ]}
    />
  );
};

JourneysConstituentsActions.propTypes = {
  selected: PropTypes.array,
  handleRemove: PropTypes.func,
  assignedContacts: PropTypes.array,
};

export default JourneysConstituentsActions;
